import { Card, ListGroup, Placeholder } from 'react-bootstrap';
import { useIntl } from 'react-intl';
type TilePlaceholderProps = {
    icon?: boolean;
    rows?: number;
};
export const TilePlaceholder = (props: TilePlaceholderProps) => {

    const { formatMessage } = useIntl();

    const { icon, rows = 3 } = props;

    return (
        <Card aria-busy="true" aria-label={formatMessage({ id: 'loading.4959bc37', defaultMessage: 'Loading' })} className={'tile-placeholder overflow-hidden'} role="status">
            <Placeholder animation="wave" as={Card.Header} bg={'body-secondary'} style={{ minHeight: '2.5rem' }} />
            <div className={'d-flex'}>
                <ListGroup className={`flex-fill${icon ? ' border-end' : ''}`} variant="flush">
                    {Array.from({ length: rows }).map((_, key) => (
                        <Placeholder
                            animation="wave"
                            as={ListGroup.Item}
                            bg={'body-tertiary'}
                            className={'small p-3'}
                            key={key}
                        />
                    ))}
                </ListGroup>

                {icon && <Placeholder animation="wave" bg={'body-tertiary'} style={{ width: 150 }}/>}

            </div>
        </Card>
    );

};